import React from 'react';

import 'components/views/Settings/LicenseSettings/LicensePackage/styles.scss';
import { useSelector } from 'react-redux';
import { getCurrentLicense, getIsLicenseAdmin } from 'store/license/getters';
import { MESSAGES } from 'constants/messages';
import { LICENSE_PAYMENT_TYPE } from 'constants/license';
import { createCustomerPortal } from 'api/paymentAPI';
import { BUTTON_TYPE } from 'constants/common';
import Button from 'components/common/Button';

const LicensePackage = () => {
  const isAdministrator = useSelector(getIsLicenseAdmin);
  const license = useSelector(getCurrentLicense);

  const isSubscription = license.payment_type === LICENSE_PAYMENT_TYPE.SUBSCRIPTION;
  const isBundle = license.payment_type === LICENSE_PAYMENT_TYPE.BUNDLE;

  const getPortalURL = async () => {
    const URL = await createCustomerPortal();
    window.location.href = URL.session;
  };

  return (
    <div className="license-settings-package">
      <strong className="license-settings-package__title">
        {isSubscription && (
          <span>Plan: {license.subscription_info?.product_name}</span>
        )}
        {isBundle && (
          <span>Bundle</span>
        )}
      </strong>
      <div className="license-settings-package__description">
        {isSubscription && isAdministrator && (
          <Button onClick={getPortalURL} type={BUTTON_TYPE.primary}>
            {MESSAGES.manage_subscription}
          </Button>
        )}
        {isBundle && (
          <span>{license?.bundle?.title}</span>
        )}
      </div>
    </div>
  );
};

export default LicensePackage;
